import { Alloy } from "./classes";
import { STR } from "./classes";


export class SPOT_UTILITIES {
    // מחלקה זו באה לשרת את תוכנת המשחקים
    // מחלקה זו באה לשרת את תוכנת המשחקים
    // מחלקה זו באה לשרת את תוכנת המשחקים
    // מחלקה זו באה לשרת את תוכנת המשחקים
    public static cut_str_head(p_str: string, p_num_of_chars: number): string {
        return p_str.substring(p_num_of_chars);
    }

    public static cut_str_tail(p_str: string, p_num_of_chars: number): string {
        return p_str.substring(0, p_str.length - p_num_of_chars);
    }

    public static trans_dim_string_to_pair_of_numbers(p_str: string): Alloy.PairOfNumbers {

        // example "dim5x7" ====> (5,7)
        const dim_str: string = STR.cut_str_head(p_str, 3);
        const dim_parts: string[] = dim_str.split("x");
        if (dim_parts.length != 2) {
            alert("Invalid dimension string: " + p_str);
            return new Alloy.PairOfNumbers(0, 0);
        }
        const num1: number = Number(dim_parts[0]);
        const num2: number = Number(dim_parts[1]);
        if (Number.isInteger(num1) == false || Number.isInteger(num2) == false ||
            num1 <= 0 || num2 <= 0) {
            alert("Invalid dimension numbers: " + p_str);
            return new Alloy.PairOfNumbers(0, 0);
        }

        return new Alloy.PairOfNumbers(num1, num2);
    }


    public static trans_size_string_to_number(p_str: string): number {

        // example "size4chars" ====> 4
        debugger;
        const temp_str: string = STR.cut_str_head(p_str, 4);
        const num_str: string = STR.cut_str_tail(temp_str, 5);
        //alert(`num_str=${num_str}`);
        const num: number = Number(num_str);

        if (Number.isInteger(num) == false || num <= 0) {
            alert("Invalid size string: " + p_str);
            return 0;
        }

        return num;
    }

    public static trans_dim_string_to_dim_code(p_dim_string: string): number {
        // C# שב enum יש לעדכן פונקציה זו לפי ה
        // C# שב enum יש לעדכן פונקציה זו לפי ה
        // C# שב enum יש לעדכן פונקציה זו לפי ה
        // search for: "public enum SPT_DimOrSize" in C#
        if (p_dim_string == "dim3x2") return 2;
        if (p_dim_string == "dim3x3") return 3;
        if (p_dim_string == "dim4x4") return 4;
        if (p_dim_string == "dim5x5") return 5;
        if (p_dim_string == "dim6x6") return 6;
        if (p_dim_string == "dim7x7") return 7;
        if (p_dim_string == "dim8x8") return 8;
        if (p_dim_string == "size4chars") return 51;
        if (p_dim_string == "size6chars") return 52;
        if (p_dim_string == "size8chars") return 53;

        return 1; // Unknown
    }

}
